import { createFileRoute, Outlet } from "@tanstack/react-router";
import { validateCameraSearch } from "./-search-params";

/**
 * Pathless layout route for AI camera assessment screens.
 * Groups: front-camera-ai, back-camera-ai
 */
export const Route = createFileRoute("/$locale/$partner/_camera")({
	validateSearch: validateCameraSearch,
	component: CameraLayout,
});

function CameraLayout() {
	return <Outlet />;
}
